export class DiagnosisCodes{
    diagnosis1: string = '';
    diagnosis2: string = '';
    diagnosis3: string = '';
    diagnosis4: string = '';
}